import { combineReducers } from "redux";
import authReducer from "./../Auth/authReducer";
import commonListingReducer from "./../CommonListing/reducer";
import appReducer from "./../Application/reducer";
import EngageMentdetailMasterReducer from "../EngagementDetails/reducer";
import engagementDetailsReducer from "../EngagementDetails/EngagementDetailsReducer";
import EditPartnerReducer from "../EditPartner/EditPartnerReducer";
import locationReducer from "./../Location/reducer";
import firmDetailMasterReducer from "../firmDetails/addFirmDetailsReducer";
import partnerReducer from "./../PartnerActions/reducer";
import branchLocationReducer from "../BranchDetails/branchLocationReducer";
import GstReducer from "../BranchGSTVerification/gstReducer";
import ContactReducer from "../BranchContact/reducer";
import accountNOVerifyReducer from "../FirmBankDetails/reducer";
import savePanNumFirmReducer from "../FirmPanDetails/reducers";
import nextPageReducer from "../NextPage/NextPageReducer";
import saveFirmDetailsReducer from "../YourFirmDetails/reduces";
import teamsDetailMasterReducer from "../TeamDetailsMaster/reducers";
import sideBarTeamsReducer from "../SideBarTeams/reducers";
import directDetailsReducer from "../TeamsDirectorPartnerDetails/reduces";
import verificationMasterReducer from "../VerificationInfoMaster/reducer";
import saveRucInfoReducer from "../RcuInfoEditPartner/reducers";
import saveverificatedReducer from "../VerificationInfoApproval/reducers";
import DocumentMasterReducer from "../Documents/Master/DocumentMasterReducer";
import UploadDocumentsReducer from "./../Documents/Upload/UploadDocumentsReducer";
import TeamDetailsReducer from "./../TeamDetails/reducer";
import saveAadharNumTeamsReducer from "../TeamsAadherVerification/reducers";
import saveDeactivePartnerReducer from "../DeactivePartner/reducers";
import getDocumentReducer from "../Documents/Get/GetDocumentsReducer";
import SubmitDocumentsForApprovalReducer from "../Documents/SubmitAll/SubmitDocumentsForApprovalReducer";

import PartnerSidebarReducer from "../PartnerSidebar/PartnerSidebarReducer";
import saveChangeRMReducer from "../ChangeRm/reduces";
import saveResendLinkReducer from "../ResendLinkRegistration/reducser";
import saveChangeSignatoryReducer from "../ChangeSignatory/reducers";
import getAddEmployeeReducer from "../AddEmployee/reducer";
import saveDeleteBranchIdReducer from "../DeleteBranchName/reduces";
import AccessMangementReducer from "../AccessManagement/AccessMangementReducer";
import bankDetailsReducer from "../bankDetailsDropdown/BankDetailsDropdownReducer";
import PanDocsReducer from "./../viewPartnerDocuments/reducer";
import saveDeactiveEmployeeReducer from "../DeactiveEmployee/reducers";
import saveResendLinkEmployeeReducer from "../ResentMailAddEmployee/reducers";
import ProgressReducer from "./../progressBar/reducer";
import LeadListingReducer from "../LeadMangement/LeadListingReducer";
import saveDeleteTeamIdReducer from "../DeleteTeamsDetails/reduces";
import Logout from "../logout/reducer";
import saveThresholdReducer from "../saveChangeThreshold/reducser";
import getThresholdChangeReducer from "../ChangeThreshold/reducers";
import getViewLeadManagementReducer from "../ViewLeadMasterData/reducer";
import BranchSaveAllReducer from "../BranchSaveAll/BranchSaveAllReducer";
import TeamSaveAllReducer from "../TeamSaveAll/TeamSaveAllReducers";
import branchCountReducer from "../BranchCount/reducer";
import viewLeadReducer from "./../viewlead/reducer";
import IifscDropdownReducer from "../iifscDropDown/reducer";
import branchPreferenceReducer from "../BranchPrefernces/reducer";
import getAllAddLeadDataReducer from "../AddLead/reducers";
import dashboardReducer from "../DashBoard/reducer";
import pricingPartnerReducer from "../PricingPartnerDetails/pricingPartnerDetailReducer";
import pricingFormSetupReducer from "../PricingSetupCategory/pricingSetupCategoryReducer";
import addPartnerPricingDetailsReducer from "../AddPartnerPricingInfo/reducer";
import partnerPricingDataWithStageReducer from "../PartnerPicingdatabystage/reducer";
import userListingReducer from "../UserManagement/UserListingReducer";
import payoutListByFYReducer from "../PayoutListByFY/Reducer";
import payoutMissingMonthforGenReportReducer from "../PayoutMissingMonthforGenReport/reducer";
import payoutRegenerateHistoryReducer from "../PayoutRegenerateHistory/reducer";
import payoutApprovalStagesReducer from "../PayoutApprovalStages/reducer";
import payoutPartnerDataReducer from "../PayoutPartnerData/reducer";
import payoutQueryInternalReducer from "../PayoutQueryInternal/Reducer";
import payoutLanDataReducer from "../PayoutLanData/Reducer";
import { partnerPayoutListByFy, partnerPayoutListByFyAction } from "../PartnerPayoutListByFy/action";
import partnerPayoutListByFyReducer from "../PartnerPayoutListByFy/reducer";
import partnerPayoutSummaryLanDataReducer from "../PartnerPayoutLanData/reducer";

// import getLeadDocumentReducer from "../AddLeadDocument/reducer";

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: commonListingReducer,
  accessManagement: AccessMangementReducer,
  leadListing: LeadListingReducer,
  application: appReducer,
  firmDetails: saveFirmDetailsReducer,
  EngagementDetails: EngageMentdetailMasterReducer,
  engagementDetails: engagementDetailsReducer,
  editPartner: EditPartnerReducer,
  location: locationReducer,
  partner: partnerReducer,
  branchLocation: branchLocationReducer,
  contactDetails: ContactReducer,
  BranchGst: GstReducer,
  accountNOVerify: accountNOVerifyReducer,
  firmPanVerify: savePanNumFirmReducer,
  nextPage: nextPageReducer,
  teamsMasterData: teamsDetailMasterReducer,
  teamSideBar: sideBarTeamsReducer,
  saveDirectorDetails: directDetailsReducer,
  firmDetailMaster: firmDetailMasterReducer,
  verificationMasterList: verificationMasterReducer,
  rcuInfoDetails: saveRucInfoReducer,
  verificationDataInfo: saveverificatedReducer,
  documentsMaster: DocumentMasterReducer,
  uploadDocuments: UploadDocumentsReducer,
  TeamDetails: TeamDetailsReducer,
  aadharVerification: saveAadharNumTeamsReducer,
  deactivePartner: saveDeactivePartnerReducer,
  getDocuments: getDocumentReducer,
  submitAllDocumentsData: SubmitDocumentsForApprovalReducer,
  changeSignatoryData: saveChangeSignatoryReducer,
  partnerSidebar: PartnerSidebarReducer,
  changeRm: saveChangeRMReducer,
  resendLink: saveResendLinkReducer,
  addEmployeeData: getAddEmployeeReducer,
  deleteBranchId: saveDeleteBranchIdReducer,
  bankDetailsDropdown: bankDetailsReducer,
  PanDocs: PanDocsReducer,
  deactiveEmployee: saveDeactiveEmployeeReducer,
  resendLinkEmployee: saveResendLinkEmployeeReducer,
  Progress: ProgressReducer,
  deleteTeamId: saveDeleteTeamIdReducer,
  thresholdData: getThresholdChangeReducer,
  saveThreshold: saveThresholdReducer,
  branchSaveAll: BranchSaveAllReducer,
  teamSaveAll: TeamSaveAllReducer,
  Logout: Logout,
  BranchCount: branchCountReducer,
  getViewLeadManagement: getViewLeadManagementReducer,
  viewLead: viewLeadReducer,
  iifscData: IifscDropdownReducer,
  branchpreference: branchPreferenceReducer,
  AddLead: getAllAddLeadDataReducer,
  // UploadList: getLeadDocumentReducer,
  dashboardReducer: dashboardReducer,
  pricigPartner: pricingPartnerReducer,
  pricingFormSetup:pricingFormSetupReducer,
  AddPricingDetail:addPartnerPricingDetailsReducer,
  partnerPricingDataWithStage:partnerPricingDataWithStageReducer,

  userListingReducer: userListingReducer,
  payoutListByFY: payoutListByFYReducer,
  payoutMissingMonthforGenReport: payoutMissingMonthforGenReportReducer,
  payoutRegenerateHistory: payoutRegenerateHistoryReducer,
  payoutApprovalStages : payoutApprovalStagesReducer,
  payoutPartnerData : payoutPartnerDataReducer,
  payoutQueryInternalReducer : payoutQueryInternalReducer,
  payoutLanDataReducer: payoutLanDataReducer,
  partnerPayoutListByFy: partnerPayoutListByFyReducer,
  partnerpayoutLanReportSummary: partnerPayoutSummaryLanDataReducer,
});

export default rootReducer;
